import type { FormFieldTypeValue } from '@cli-types/core-engine/schema.js'
import { FORM_FIELD_TYPES } from '@cli-constants/schema.js'

export function isFormFieldType(value: string): value is FormFieldTypeValue {
  return Object.values(FORM_FIELD_TYPES).includes(value as FormFieldTypeValue)
}
